import {Navigate} from 'react-router-dom';
import { useSelector } from 'react-redux';
const PrivateRoute = ({children})=>{
   const authenticated = useSelector((state)=>{
      return state.root.authenticated
   })
   return authenticated ? children : <Navigate to='/login'/>
}

export default PrivateRoute